export const optionDefaultClass = 'text-neutral-700 dark:text-neutral-200'
export const optionActiveClass =
  'bg-neutral-100 dark:bg-neutral-300 export text-neutral-900'

export const iconClass = (
  option: boolean,
  optionEnabled = true,
  spin = false,
) => ({
  'bg-neutral-50 border rounded-sm shadow-inner h-6 w-6 p-1 dark:text-neutral-300 dark:bg-neutral-600':
    option && optionEnabled,
  'mr-3 h-5 w-5': true,
  'text-neutral-300 dark:text-neutral-500 opacity-50': !optionEnabled,
  'text-neutral-400': optionEnabled,
  'dark:group-hover:text-neutral-200': optionEnabled && option,
  'animate-spin': spin,
})

export const optionClass = (optionEnabled: boolean, active: boolean) => ({
  'group flex items-center px-4 py-2 text-sm': true,
  'bg-neutral-100 dark:bg-neutral-600 text-neutral-900 dark:text-neutral-200':
    active && optionEnabled,
  'text-neutral-800 dark:text-neutral-200': !active && optionEnabled,
  'text-blue-300 dark:text-neutral-500': !optionEnabled,
})
